import { SvgIconVariables } from '../../../teams/components/SvgIcon/svgIconVariables';

export const svgIconVariables = (siteVars): Partial<SvgIconVariables> => ({
  disabledColor: siteVars.colors.grey[450],
});
